import {createAsyncThunk} from '@reduxjs/toolkit'

import {PC_PAY, PAY} from '@web/core/urls'
import {changeBrowserLocation} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {LocationChangeHistoryParam, ThunkApi} from '../interfaces'

const PAY_HOME_URL = `${PC_PAY}/mypage/home`
const PAY_HOME_MOBILE_URL = `${PAY}/mydata/home`

/**
 * 페이홈 마이페이지로 이동
 */
const navigateToPayHome = createAsyncThunk<void, LocationChangeHistoryParam | void, ThunkApi>(
    'navigateTo/payHome',
    async (args) => {
        const {historyType = 'PUSH'} = args ?? {}
        const url = isMobile ? PAY_HOME_MOBILE_URL : PAY_HOME_URL

        changeBrowserLocation({url, type: historyType})
    },
)

export default navigateToPayHome
